import {
  registerDecorator,
  ValidationOptions,
  ValidationArguments,
  ValidatorConstraintInterface,
  ValidatorConstraint,
} from 'class-validator';
import { ErrorCode } from '../../../constants/src';

@ValidatorConstraint({ name: '_ArrayNotEmpty', async: false })
export class ArrayNotEmptyConstraint implements ValidatorConstraintInterface {
  validate(value: unknown) {
    return Array.isArray(value) && value.length > 0;
  }

  defaultMessage(args: ValidationArguments) {
    const [errorCode] = args.constraints;

    return JSON.stringify({
      code: errorCode,
      message: `${args.property} must be a non-empty array`,
      path: args.property,
      params: {
        currentValue: args.value,
      },
    });
  }
}

export function ArrayNotEmpty(
  errorCode: ErrorCode = ErrorCode.INVALID_INPUT,
  validationOptions?: ValidationOptions,
) {
  return function (object: object, propertyName: string) {
    registerDecorator({
      name: '_arrayNotEmpty',
      target: object.constructor,
      propertyName: propertyName,
      options: validationOptions,
      constraints: [errorCode],
      validator: ArrayNotEmptyConstraint,
    });
  };
}
